import React, { useEffect } from 'react'
import SideBar from '../common/layout/sidebar.component.jsx'
import RoleEditForm from './form/edit.component.jsx'

const RoleNew = (props) => {
    useEffect(() => {
        SideBar.activateMenu('account')
    }, [])

    return (
        <div>
            <RoleEditForm />
        </div>
    )
}

export default RoleNew



// WEBPACK FOOTER //
// ./src/role/new.component.jsx